<template>
  <footer class="sticky-footer bg-white">
		<div class="container my-auto">
			<div class="copyright text-center my-auto">
				<span>Copyright &copy; <a href="https://gobi.my">GoBI</a> 2019-2020</span>
			</div>
		</div>
  </footer>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
@Component
export default class AppFooter extends Vue {}
</script>